import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import smoothscroll from 'smoothscroll-polyfill';
import Store from './hooks/Store';

import AOS from 'aos';
import 'aos/dist/aos.css';

// Dates managements and rendering
import Moment from "react-moment";
import moment from 'moment';
import 'moment-timezone';

// Internationalization
import './i18n';

// Previous browsers' versions support
smoothscroll.polyfill();

AOS.init({
    once: true,
    mirror: false
});

// Sets the moment instance to use.
Moment.globalMoment = moment;
// Set the locale for every react-moment instance to French.
Moment.globalLocale = 'it';
// Set the output format for every react-moment instance.
Moment.globalFormat = 'D MMM YYYY';

ReactDOM.render(
    <Store>
        <React.StrictMode>
    <App />
        </React.StrictMode>
    </Store>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
